import { getState } from "../../app/StoreFactory";
import { setCookie } from "lib/cookieUtils";
import { preferencesSlice } from "redux/slices/preferencesSlice";
import { postPreferences } from "../../api/preferences/postPrefrences";

export const setPreference = (payload, isPost) => {
  return (dispatch) => {
    dispatch(preferencesSlice.actions.set(payload));
    savePreferenceAsCookie(payload);
    isPost && postPreferences(getState().preferences);
  };
};

export const togglePreference = (payload) => {
  return (dispatch) => {
    dispatch(preferencesSlice.actions.toggle(payload));
    savePreferenceAsCookie(payload);
  };
};

export const mergePreferences = (payload) => {
  return (dispatch) => {
    dispatch(preferencesSlice.actions.merge(payload));
    savePreferencesAsCookies();
  };
};

const savePreferenceAsCookie = ({ key }) => {
  const value = getState().preferences[key].join();
  flattenAndSetCookie(key, value);
};

const savePreferencesAsCookies = () => {
  const preferences = getState().preferences;
  Object.entries(preferences).forEach(([key, value]) => {
    flattenAndSetCookie(key, value);
  });
};

const flattenAndSetCookie = (key, value) => {
  const flattenedValue = Array.isArray(value) ? value.join() : value;
  setCookie(key, flattenedValue);
};
